import { isEmptyString } from '@/utils/string';

const WORKSPACE_ID_URL_REGEX = /\/workspaces\/(\d*)(\/?|\/.*)$/;

export function getWorkspaceIdFromUrl(path: string) {
  const result = path.match(WORKSPACE_ID_URL_REGEX);
  if (result != null && result.length > 2) {
    const match = result[1];

    if (isEmptyString(match)) {
      return null;
    }

    return match;
  }
  return null;
}

export function getWorkspaceIdFromCurrentUrl(): number | null {
  const currentUrl = window.location.href;
  const workspaceIdString = getWorkspaceIdFromUrl(currentUrl);
  const workspaceId = Number(workspaceIdString);
  if (workspaceIdString !== null && !Number.isNaN(workspaceId)) {
    return workspaceId;
  } else {
    // Preserve the null to support possible downstream error checks
    return null;
  }
}
